import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type TypeOrgUser = {
  id: number;
  orgId: number;
};

type UserState = {
  orgUsers: Record<number, TypeOrgUser> | null;
  setOrgUsers: (user: TypeOrgUser) => void;
};

const useUserStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        orgUsers: null,
        setOrgUsers: (user) =>
          set((state) => ({
            orgUsers: {
              ...state.orgUsers,
              [user.id]: user,
            },
          })),
      }),
      { name: 'userStore' }
    )
  )
);

export const useUserState = () =>
  useUserStore((state) => ({
    orgUsers: state.orgUsers,
  }));

export const useUserActions = () =>
  useUserStore((state) => ({
    setOrgUsers: state.setOrgUsers,
  }));

export default useUserStore;
